import React from 'react';
import { Link } from 'react-router-dom';

export default function DataProtectionCheckbox({ checked, onChange, id = "privacy-consent" }) {
  return (
    <div className="mt-4 space-y-3" data-testid={`${id}-wrapper`}>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 w-4 h-4 accent-rose-600 flex-shrink-0"
          required
          data-testid={id}
        />
        <span className="text-xs text-slate-600 leading-relaxed">
          He leído y acepto la{' '}
          <Link to="/legal/privacidad" target="_blank" className="text-rose-600 underline hover:text-rose-700">
            Política de Privacidad
          </Link>
          {' '}y consiento el tratamiento de mis datos para la finalidad indicada.
        </span>
      </label>

      {/* Primera capa de información LOPD — siempre visible */}
      <div className="ml-7 p-3 bg-slate-50 border border-slate-200 text-[10px] text-slate-500 leading-relaxed space-y-1" data-testid={`${id}-info-layer`}>
        <p><strong>Responsable:</strong> José Luis Vilaplana Villajos — tecnoabogado.com</p>
        <p><strong>Finalidad:</strong> Gestionar su solicitud de contacto, información o consulta y, en su caso, enviarle comunicaciones relacionadas con nuestros servicios.</p>
        <p><strong>Legitimación:</strong> Consentimiento del interesado (Art. 6.1.a RGPD).</p>
        <p><strong>Destinatarios:</strong> No se cederán datos a terceros salvo obligación legal. Los datos podrán ser tratados por proveedores de servicios (hosting, email) bajo acuerdo de encargado de tratamiento.</p>
        <p><strong>Derechos:</strong> Acceso, rectificación, supresión, limitación, portabilidad y oposición, dirigiéndose a <a href="mailto:info@tecnoabogado.com" className="underline">info@tecnoabogado.com</a>.</p>
        <p><strong>Información adicional:</strong> Consulte la información detallada en nuestra{' '}
          <Link to="/legal/privacidad" target="_blank" className="text-rose-600 underline">Política de Privacidad</Link>.
        </p>
      </div>
    </div>
  );
}
